// This enum is used to represent the type of questionnaire
export enum QuestionnaireTypeEnum {
  NPS = 'NPS',
  FEEDBACK = 'FEEDBACK',
  SURVEY = 'SURVEY',
  BUILD_WITH_AI = 'BUILD_WITH_AI',
}

// This enum is used to represent the sub type of questionnaire
export enum QuestionnaireSubTypeEnum {
  QR_BASED_SURVEY = 'QR_BASED_SURVEY',
  GENERIC_SURVEY = 'GENERIC_SURVEY',
  GENERIC_NPS = 'GENERIC_NPS',
  EVENT_BASED_NPS = 'EVENT_BASED_NPS',
  GENERIC_FEEDBACK = 'GENERIC_FEEDBACK',
  EVENT_BASED_FEEDBACK = 'EVENT_BASED_FEEDBACK',
}


export enum UserInfoCaptureStatus {
  ANANYMOUS = 'ANANYMOUS',
  OPTIONAL = 'OPTIONAL',
  MANDATORY = 'MANDATORY',
}

export enum ResponseFrequencyEnum {
  DAILY = 'DAILY',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
}

export enum KeyIdentifierTypeEnum {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  EMPLOYEE_ID = 'EMPLOYEE_ID',
  ORDER_ID = 'ORDER_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  FLIGHT_NUMBER = 'FLIGHT_NUMBER',
  POLICY_NUMBER = 'POLICY_NUMBER',
  PATIENT_ID = 'PATIENT_ID',
  CUSTOMER_ID = 'CUSTOMER_ID',
  MEMBERSHIP_ID = 'MEMBERSHIP_ID',
  SUBSCRIPTION_ID = 'SUBSCRIPTION_ID',
}


export enum UserInfoFieldsEnum {
  NAME = 'NAME',
  AGE = 'AGE',
}






export enum QuestionType {
  CHOICE_BASED = 'CHOICE_BASED',
  TEXT_INPUT = 'TEXT_INPUT',
  SLIDERS = 'SLIDERS',
  RATING_SCALE = 'RATING_SCALE',
  NPS = 'NPS',
  RANK_ORDER = 'RANK_ORDER',
  MATRIX_TABLE = 'MATRIX_TABLE',  
  SOCIAL_REVIEW = 'SOCIAL_REVIEW',   
  UPLOAD_FILE = 'UPLOAD_FILE',
}

export enum QuestionSubType {
  LIST = 'LIST',
  DROPDOWN = 'DROPDOWN',
  IMAGE_CHOICE = 'IMAGE_CHOICE',
  BUTTON_CHOICE = 'BUTTON_CHOICE',
  SHORT_TEXT = 'SHORT_TEXT',
  LONG_TEXT = 'LONG_TEXT',
  NUMBERS = 'NUMBERS',
  FULL_NAME = 'FULL_NAME',
  EMAIL = 'EMAIL',
  PHONE_NUMBER = 'PHONE_NUMBER',
  WEBSITE_URL = 'WEBSITE_URL',
  CALENDAR = 'CALENDAR',
  SLIDER='SLIDER',
  OPINION_SCALE = 'OPINION_SCALE',
  RATING_SCALE = 'RATING_SCALE',
  // STAR_RATING = 'STAR_RATING',
  NPS= 'NPS',
  LIST_GRID = 'LIST_GRID',
  OPINION_GRID = 'OPINION_GRID',
  RATING_GRID = 'RATING_GRID',
  DROPDOWN_GRID = 'DROPDOWN_GRID',
  SLIDER_GRID = 'SLIDER_GRID',
  BEST_WORST_GRID = 'BEST_WORST_GRID',
  RANKING = 'RANKING',
  GOOGLE = 'GOOGLE',
  FILE_UPLOAD = 'FILE_UPLOAD',
}

export enum Alignment {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export enum RatingScaleSubType {
  STAR = 'STAR',
  EMOJI = 'EMOJI',
  NUMBER = 'NUMBER',
  HEART = 'HEART',
  SMILE = 'SMILE',
  SAD = 'SAD',
  ANGRY = 'ANGRY',
  THUMBS_UP = 'THUMBS_UP',
  THUMBS_DOWN = 'THUMBS_DOWN',
}

export enum NPSRepresentation {
  BOXES = 'BOXES',
  CIRCLES = 'CIRCLES',
  RECTANGLES = 'RECTANGLES',
}

export enum NPSColor {
  GRADIENT = 'GRADIENT',
  TRICOLOR = 'TRICOLOR',
  // DEFAULT = 'DEFAULT',
}

export enum QRBasedPageType {
  QR_PAGE =  'QR_PAGE',
  PREVIEW_PAGE ='PREVIEW_PAGE'
}

export enum RedirectionOption {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
}

export enum QuestionConditionParameter {
  RATING = 'RATING',
  // CHOICE = 'CHOICE',
}

export enum QuestionConditionOperator {
  EQUALS = 'EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  // LESS_THAN = 'LESS_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  // LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  // NOT_EQUALS = 'NOT_EQUALS',
}

export enum QuestionConditionValue {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
}

